/**
 * v2 mock — auto-rotating reviews carousel (fade + subtle float).
 *
 * Markup contract:
 *   <div data-ww-reviews data-ww-interval="4500" data-ww-per-view="3">
 *     <div data-ww-review> ... </div>   (2+ reviews)
 *     ...
 *     <button data-ww-dot></button>     (optional, one per PAGE)
 *   </div>
 *
 * data-ww-per-view (default 1): how many reviews advance together as one
 * "page". On viewports under 750px the module always falls back to 1 per
 * page regardless of the attribute, matching the mobile CSS (one review
 * shown at a time).
 *
 * Fail-safe: base CSS shows only the first page's reviews. This module opts
 * the container into the animated stack by adding `.ww-js-reviews`, so if
 * the module never runs, the first page stays visible on its own.
 *
 * Reduced motion: honours prefers-reduced-motion by doing nothing — base CSS
 * (first page only, no auto-advance) is the reduced-motion presentation.
 *
 * Pauses on hover / focus within the carousel, and when the tab is hidden.
 */
(function () {
  if (window.__wwReviewsInit) return;
  window.__wwReviewsInit = true;

  var reduce =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mobileQuery = window.matchMedia && window.matchMedia('(max-width: 749px)');

  function initOne(root) {
    if (root.__wwReviews) return;
    root.__wwReviews = true;

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-ww-review]'));
    if (slides.length < 2) return;
    if (reduce) return;

    var interval = parseInt(root.getAttribute('data-ww-interval'), 10) || 4500;
    var perViewAttr = parseInt(root.getAttribute('data-ww-per-view'), 10) || 1;
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-ww-dot]'));
    var currentPage = 0;
    var timer = null;

    function perView() {
      return mobileQuery && mobileQuery.matches ? 1 : perViewAttr;
    }

    function pageCount() {
      return Math.ceil(slides.length / perView());
    }

    function setDot(i) {
      // Dots are rendered for the desktop page count (3). On mobile there
      // are more pages (1 review each) than dots, so wrap the highlight
      // rather than let it run out and leave every dot dark.
      if (!dots.length) return;
      var active = i % dots.length;
      dots.forEach(function (d, di) {
        d.classList.toggle('is-active', di === active);
      });
    }

    function applyPage(page) {
      var pv = perView();
      var start = page * pv;
      var end = start + pv;
      slides.forEach(function (s, i) {
        s.classList.toggle('is-active', i >= start && i < end);
      });
      setDot(page);
    }

    root.classList.add('ww-js-reviews');
    currentPage = 0;
    applyPage(currentPage);

    function go(next) {
      var pages = pageCount();
      currentPage = (next + pages) % pages;
      applyPage(currentPage);
    }

    function advance() {
      go(currentPage + 1);
    }

    function start() {
      if (!timer) timer = window.setInterval(advance, interval);
    }
    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    // Pause on hover / keyboard focus.
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else start();
    });

    // Optional: click a dot to jump.
    dots.forEach(function (d, di) {
      d.addEventListener('click', function () {
        go(di);
      });
    });

    // Breakpoint crossing changes per-view (3 <-> 1) — reset to page 0
    // rather than trying to preserve a now-invalid page index.
    if (mobileQuery && mobileQuery.addEventListener) {
      mobileQuery.addEventListener('change', function () {
        currentPage = 0;
        applyPage(currentPage);
      });
    }

    start();
  }

  function initAll() {
    document.querySelectorAll('[data-ww-reviews]').forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
